<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Button, Modal } from '@Shelly/shelly-design-system';
	import { capFirstChar } from 'src/helpers/utilities';
	import AcceptTermsAndAge from './AcceptTermsAndAge.svelte';

	export let showModal = false;
	export let callback = () => {};

	let accepted = false;
</script>

<Modal
	on:close={() => (showModal = false)}
	{showModal}
	title={capFirstChar(
		$format('modal_title_subscription_details', {
			default: 'subscription details',
		}),
	)}
	backdropClose
	removeScrollPadding
>
	<AcceptTermsAndAge bind:accepted slot="content" />
	<div slot="footer" class="d-flex justify-content-end">
		<Button
			class="mr-s"
			responsiveSize={{
				sm: 'm',
			}}
			variant="secondary"
			on:click={() => (showModal = false)}
		>
			{$format('button_cancel', { default: 'Cancel' })}
		</Button>
		<Button
			disabled={!accepted}
			responsiveSize={{
				sm: 'm',
			}}
			on:click={callback}
		>
			{capFirstChar(
				$format('button_invoice_details_modal_pay_subscribe', {
					default: 'Pay and subscribe',
				}),
			)}
		</Button>
	</div>
</Modal>
